module["exports"] = [
  "Gruppen",
  "AB",
  "HB",
  "Group",
  "Investment",
  "Kommanditbolag",
  "Aktiebolag"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/company/suffix.js
// module id = 1701
// module chunks = 0